<template>
  <div id="discord-authorize">
    <v-container>
      <v-card
        v-if="loading && this.$route.params.type === 'link'"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">Loading...</p>
        </v-container>
      </v-card>
      <v-card
        v-if="!loading && linked && this.$route.params.type === 'link'"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">Your Discord account has been linked.</p>
        </v-container>
      </v-card>
      <v-card
        v-if="!loading && !linked && this.$route.params.type === 'link'"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">
            Your Discord account could not be linked, the error message is
            below:
          </p>
          <p
            v-for="item in $store.state.errorHandler.errors"
            :key="item"
            class="text-subtitle-1"
          >
            {{ item }}
          </p>
        </v-container>
      </v-card>
      <v-card
        v-if="loading && this.$route.params.type === 'login'"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">Logging you in...</p>
        </v-container>
      </v-card>
      <v-card
        v-if="!loading && this.$route.params.type === 'login' && !fail"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">You have been logged in. Redirecting...</p>
        </v-container>
      </v-card>
      <v-card
        v-if="!loading && this.$route.params.type === 'login' && fail"
        class="rounded-xl"
        elevation="7"
      >
        <v-container class="text-center">
          <p class="text-lg-h4">
            There was an issue while logging in, the error message is below:
          </p>
          <p
            v-for="item in $store.state.errorHandler.errors"
            :key="item"
            class="text-subtitle-1"
          >
            {{ item }}
          </p>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "DiscordAuthorize",
  data() {
    return {
      loading: true,
      linked: false,
      fail: false
    }
  },
  methods: {
    linkDiscord() {
      this.loading = true
      this.axios
        .put("/api/v1/userutils/settings/linkDiscord", {
          code: this.$route.query.code
        })
        .then(() => {
          this.loading = false
          this.linked = true
        })
        .catch((e) => {
          this.fail = true
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    loginDiscord() {
      this.loading = true
      this.axios
        .post("/api/v1/auth/login/external/discord", {
          code: this.$route.query.code
        })
        .then((res) => {
          this.loading = false
          this.$store.commit("login", res.data)
          localStorage.setItem("token", res.data.token)
          Object.assign(this.axios.defaults, {
            headers: { Authorization: this.$store.state.user.token }
          })
          this.axios
            .get("/api/v1/userutils/info")
            .then((res) => {
              this.$store.commit("login", res.data)
              this.$router.push("/")
              this.$toast("You have been logged in.", {
                timeout: 3000,
                type: "success"
              })
            })
            .catch((e) => {
              AjaxErrorHandler(this.$store)(e)
            })
        })
        .catch((e) => {
          this.loading = false
          this.fail = true
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    if (this.$route.params.type === "link") {
      this.linkDiscord()
    } else if (this.$route.params.type === "login") {
      this.loginDiscord()
    }
  }
}
</script>

<style scoped></style>
